export const categories = [
  {
    id: 'movie',
    name: '电影大片',
    slug: 'movie',
    description: '最新院线电影、经典影片、国际电影节获奖作品',
    videoCount: 2840,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20scene%20with%20warm%20ambient%20lighting%2C%20elegant%20film%20reels%20and%20popcorn%2C%20dark%20atmospheric%20background%2C%20professional%20editorial%20photography%2C%20rich%20warm%20tones%20and%20soft%20shadows&width=600&height=800&seq=cat-movie&orientation=portrait',
  },
  {
    id: 'tv',
    name: '电视剧集',
    slug: 'tv',
    description: '热播国产剧、韩剧、美剧、日剧全收录',
    videoCount: 5620,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20glowing%20TV%20screen%20at%20night%2C%20comfortable%20sofa%20with%20soft%20blankets%2C%20warm%20indoor%20lighting%2C%20modern%20home%20entertainment%20setup%2C%20editorial%20lifestyle%20photography%20with%20soft%20neutral%20tones&width=600&height=800&seq=cat-tv&orientation=portrait',
  },
  {
    id: 'variety',
    name: '综艺节目',
    slug: 'variety',
    description: '热门综艺、真人秀、脱口秀、音乐节目',
    videoCount: 1890,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20performance%20scene%20with%20colorful%20spotlights%2C%20microphone%20stand%20and%20confetti%2C%20entertainment%20show%20atmosphere%2C%20warm%20golden%20and%20orange%20lighting%2C%20professional%20concert%20photography%20with%20dramatic%20composition&width=600&height=800&seq=cat-variety&orientation=portrait',
  },
  {
    id: 'anime',
    name: '动漫动画',
    slug: 'anime',
    description: '日本动漫、国产动画、欧美卡通精选',
    videoCount: 3240,
    image: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20style%20scene%20with%20colorful%20anime%20characters%20and%20dreamy%20background%2C%20soft%20pastel%20gradient%20sky%20with%20cherry%20blossoms%2C%20warm%20creative%20atmosphere%2C%20digital%20art%20with%20harmonious%20composition%20and%20gentle%20lighting&width=600&height=800&seq=cat-anime&orientation=portrait',
  },
  {
    id: 'documentary',
    name: '纪录片',
    slug: 'documentary',
    description: '自然、历史、人文、科技纪录片精选',
    videoCount: 1560,
    image: 'https://readdy.ai/api/search-image?query=Majestic%20nature%20landscape%20photography%20with%20mountain%20peaks%20at%20golden%20hour%2C%20documentary%20film%20camera%20silhouette%20in%20foreground%2C%20dramatic%20clouds%20and%20warm%20sunlight%2C%20cinematic%20wide%20angle%20composition%20with%20rich%20earthy%20tones&width=600&height=800&seq=cat-doc&orientation=portrait',
  },
  {
    id: 'music',
    name: '音乐MV',
    slug: 'music',
    description: '热门歌曲MV、演唱会现场、音乐纪录片',
    videoCount: 2100,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20music%20concert%20scene%20with%20singer%20silhouette%20under%20dramatic%20stage%20lights%2C%20guitar%20and%20musical%20instruments%20arrangement%2C%20warm%20amber%20and%20golden%20spotlight%20beams%2C%20professional%20concert%20photography%20with%20atmospheric%20smoke%20effects&width=600&height=800&seq=cat-music&orientation=portrait',
  },
];

export const categorySlugs = categories.map((c) => c.slug);